import { render, staticRenderFns } from "./QuickWordsManage.vue?vue&type=template&id=8b9771be&scoped=true&"
import script from "./QuickWordsManage.vue?vue&type=script&lang=js&"
export * from "./QuickWordsManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9771be",
  null
  
)

export default component.exports